import React from "react";
import {
  Box,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Skeleton,
} from "@mui/material";
import { Check } from "@mui/icons-material";

const StepItem = ({ number, title, value, render }) => {
  const isComplete = isFilled(value);
  const customTheme = useTheme();

  function isFilled(value) {
    if (Array.isArray(value)) return value.length > 0;
    if (value && typeof value === "object") return Object.values(value).every(isFilled);
    return Boolean(value);
  }

  return (
    <Box
      key={number}
      sx={{
        display: "flex",
        gap: 3,
        alignItems: "flex-start",
        p: 2,
        bgcolor: "transparent",
      }}
    >
      {/* Step Circle */}
      <Box
        sx={(theme) => ({
          width: { xs: 40, sm: 50 },
          height: { xs: 40, sm: 50},
          borderRadius: "50%",
          color: isComplete ? "tertiary.light" : "primary.main",
          bgcolor: !isComplete ? "secondary.main" : "primary.main",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          variant: {xs : "body", sm: "subtitle"},
          // fontSize: (theme) => ({
          //   xs: theme.typography.subtitle1.fontSize,
          //   sm: theme.typography.h3.fontSize,
           
          // }),
          flexShrink: 0,
        })}
      >

        {isComplete ? <Check fontWeight="900" fontSize="inherit" /> : number}
      </Box>

      {/* Step Content */}
      <Box>
        <Typography variant="subtitle" sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
          {title}
        </Typography>
        <Typography component="div" variant="body" sx={{ mt: 0.5 }}>
          {render(value)}
        </Typography>
      </Box>
    </Box>
  );
};

const SkeletonStepItem = () => (
  <Box
    sx={{
      display: "flex",
      gap: 3,
      alignItems: "flex-start",
      p: 2,
    }}
  >
    <Skeleton variant="circular" width={60} height={60} />
    <Box sx={{ flex: 1 }}>
      <Skeleton variant="text" width="40%" height={24} />
      <Skeleton variant="text" width="80%" height={18} sx={{ mt: 1 }} />
      <Skeleton variant="text" width="60%" height={18} />
    </Box>
  </Box>
);

const DataSteps = ({ steps, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack sx={{ bgcolor: "background.main" }} ml={isMobile ? 2 : 7} mt={2}>
      {loading
        ? Array.from({ length: 3 }).map((_, i) => <SkeletonStepItem key={i} />)
        : steps.map((step) => <StepItem key={step.number} {...step} />)}
    </Stack>
  );
};

export default DataSteps;
